<template>
    <v-card class="background-card" v-resize="onResize" v-if="isReady">
        <v-overlay color="#106c68" :value="loadingState" z-index="12" style="left: -57px;">
                <span class="loader"></span>
            </v-overlay>
        <v-card-title v-if="windowSize.x > 1000" class="font-theme d-flex justify-space-between pa-0" style="border-bottom: 1px solid #BCB9B9;">
            <span style="font-weight: 600; font-size: calc(100% + 1.4vw); margin: 3.2% 0% 3.2% 4.8%; line-height: 45px; font-family: 'Sarabun', 'sans-serif';" class="text-center">
                ITEM : {{ this.selectedBiz.business_detail.name_eng.toUpperCase() }}
            </span>
            <span style="margin: 3.2% 3.2% 3.2% 0%;">
                <v-btn v-if="permissionBtnEditMode" rounded color="green" class="mr-2 white--text text-center download-report-item-btn" @click="goToAddItem()" height="53" width="193" style="font-weight: 700; font-size: 15px; box-shadow: none;">
                    Add Item
                </v-btn>
                <v-btn rounded color="#0B68D6" class="white--text text-center download-report-item-btn" @click="goToDownloadReport()" height="53" width="193">
                    Download Report
                </v-btn>
            </span>
        </v-card-title>
        <v-card-title v-else class="font-theme d-flex pa-0" style="border-bottom: 1px solid #BCB9B9;">
            <v-row no-gutters class="font-theme standard-row d-flex justify-space-between" style="padding: 3.8% 3.2% 3.8% 3.2%; line-height: 47px;">
                <v-col cols="11" sm="">
                    <span style="font-weight: 400; font-family: 'Sarabun'; font-size: calc(100% + 1.5vw);">ITEM :<br>{{ this.selectedBiz.business_detail.name_eng.toUpperCase() }}</span>
                </v-col>
                <v-col cols="1" sm="auto">
                    <v-menu offset-y transition="scroll-y-transition">
                        <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on" color="#414040">
                                <v-icon size="30">mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list style="background-color: #414040;">
                            <v-list-item dense @click="goToDownloadReport()">
                                <v-list-item-content>
                                    <v-list-item-title class="font-theme white--text" style="font-size: 16px; line-height: 25px;">Dowload Report</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item dense @click="goToAddItem()" v-if="permissionBtnEditMode">
                                <v-list-item-content>
                                    <v-list-item-title class="font-theme white--text" style="font-size: 16px; line-height: 25px;">Add Item</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list> 
                    </v-menu>
                </v-col>
            </v-row>
        </v-card-title>
        <v-row no-gutters class="standard-row d-flex justify-end" style="padding: 2.8% 3.2% 2.8% 3.2%;">
            <v-col cols="12" sm="12" md="6" lg="4">
                <v-text-field dense outlined hide-details color="black" placeholder="ค้นหาขั้นสูง" v-model="holdKeyword" @input="!holdKeyword? checkRowsAndPageBeforeSearch(holdKeyword): ''" @keyup.enter="checkRowsAndPageBeforeSearch(holdKeyword)" height="53" class="font-theme search-text-field">
                    <template v-slot:append>
                        <v-btn color="#0B68D6" class="white--text font-theme search-item-btn" @click="checkRowsAndPageBeforeSearch(holdKeyword)">
                            Search
                        </v-btn>
                    </template>
                </v-text-field>
            </v-col>
        </v-row>
        <v-row no-gutters class="standard-row font-theme" style="padding: 0% 3.2% 3.8% 3.2%;">
            <v-data-table @click:row="detailItem($event)" :headers="headers" range :items="myItem" fixed-header class="elevation-0 data-item-table-setting" style="width: 100%" :options.sync="optionsDataTable" :server-items-length="countItem" :footer-props="{'items-per-page-options': [20, 30, 40, 50], 'items-per-page-text':'จำนวนแถวต่อหน้า'}" mobile-breakpoint="850">
                <template v-if="myItem.length < 20" v-slot:body.append="{ isMobile }">
                    <tr v-for="(_, index_tr) in (20 - myItem.length)" :key="`tr__${index_tr}`" v-show="!isMobile">
                        <td v-for="(_, index_td) in 6" :key="`td__${index_td}`"></td>
                    </tr>
                </template>
                <template slot="no-data">
                    <a class="text-center d-flex justify-center black--text" style="font-size: 16px;">
                        ไม่พบข้อมูล
                    </a>
                </template>
                <template v-slot:[`item.material_code`]="{ item }">
                    {{ item.material_code || '–' }}
                </template>
                <template v-slot:[`item.material_name`]="{ item }">
                    {{ item.material_name || '–' }}
                </template>
                <template v-slot:[`item.objective_code`]="{ item }">
                    {{ item.objective_code || '–' }}
                </template>
                <template v-slot:[`item.objective_name`]="{ item }">
                    {{ item.objective_name || '–' }}
                </template>
                <template v-slot:[`item.gl_account`]="{ item }">
                    {{ item.gl_account || '–' }}
                </template>
                <template v-slot:[`item.gl_account_name`]="{ item }">
                    {{ item.gl_account_name || '–' }}
                </template>
                <template v-slot:footer.page-text="items">
                    {{ items.pageStart }} - {{ items.pageStop }} จาก {{ items.itemsLength }} แถว
                </template>
            </v-data-table>
        </v-row>
        <v-card-title class="font-theme d-flex justify-end pa-0" style="border-top: 1px solid #BCB9B9;">
            <span style="font-weight: 400; font-size: 20px; margin: 1.95% 3.2% 1.95% 0%; line-height: 45px;" class="text-center">
                Total : {{ countItem }}
            </span>
        </v-card-title>
        <DownloadReportModal />
        <AddItemDetail/>
        <ItemDetail />
    </v-card>
</template>

<script>
import { EventBus } from '../EventBus'
import AddItemDetail from '../components/AddItemDetail.vue'
import DownloadReportModal from '../components/DownloadReportModal.vue'
import ItemDetail from '@/components/ItemDetail.vue'
    export default {
        components: {
            DownloadReportModal,
            AddItemDetail,
            ItemDetail
        },
        data: () => ({
            optionsDataTable: { page: 1, itemsPerPage: 20 },
            windowSize: { x: 0, y: 0 },
            trigRowPerPage: false,
            callApiPending: 0,
            countItem: 0,
            isReady: false,
            loadingState: false,
            myItem: [],
            keyword: '',
            holdKeyword: '',
            headers: [
                { text: "Material Code"  , value: "material_code"  , align: "center", sortable: false, width: '15.6%' },
                { text: "Material Name"  , value: "material_name"  , align: "center", sortable: false, width: '21.2%' },
                { text: "Objective Code" , value: "objective_code" , align: "center", sortable: false, width: '14.5%' },
                { text: "Objective Name" , value: "objective_name" , align: "center", sortable: false, width: '16.8%' },
                { text: "GL Account"     , value: "gl_account"     , align: "center", sortable: false, width: '10.8%' },
                { text: "GL Account Name", value: "gl_account_name", align: "center", sortable: false, width: '21%' }
            ]
        }),
        mounted () {
            this.onResize()
            this.getAllItem()
            EventBus.$on('reloadItemPage', () => {
                window.location.reload();
            });
            },
            beforeDestroy() {
                EventBus.$off('reloadItemPage')
            },
        watch: {
            "optionsDataTable.page"() {
                this.getAllItem()
                this.trigRowPerPage = true
            },
            "optionsDataTable.itemsPerPage"() {
                if (!this.trigRowPerPage) {
                    this.optionsDataTable.page = 1
                    this.getAllItem()
                }
            },
            "callApiPending"(val) {
                if (val > 0) {
                    EventBus.$emit('loadingState', true)
                } else {
                    EventBus.$emit('loadingState', false)
                }
            }
        },
        computed: {
            selectedBiz() {
                return this.$store.state.confirmSelectedBiz
            },
            raDetail() {
                return this.$store.state.raDetail
            },
            permissionBtnEditMode(){
                return this.$store.state.permissionBtnEditMode
            }
        },
        methods: {
            onResize() {
                this.windowSize = { x: window.innerWidth }
            },
            checkRowsAndPageBeforeSearch(params) {
                if (this.keyword === params) {
                    return
                }
                this.keyword = params.trim()
                if (this.optionsDataTable.page === 1) {
                    this.getAllItem()
                } else {
                    this.optionsDataTable.page = 1
                }
            },
            goToDownloadReport(){
                const aboutReport = {
                    url  : '/report/api/v1/export_reportitem',
                    from : 'add_item'
                }
                EventBus.$emit('openDownloadReportModal', aboutReport)
            },
            async getAllItem() {
                this.callApiPending++
                const countTransactions = {
                    baseURL : this.$api_url,
                    url     : `/item_erp/api/v1/count_all_item?tax_id=${this.selectedBiz.tax_id}&keyword=${this.keyword || ''}`,
                    method  : 'GET'
                }
                const searchTransactions = {
                    baseURL : this.$api_url,
                    url     : `/item_erp/api/v1/get_all_item?tax_id=${this.selectedBiz.tax_id}&keyword=${this.keyword || ''}&offset=${(this.optionsDataTable.page - 1) * this.optionsDataTable.itemsPerPage || 0}&limit=${this.optionsDataTable.itemsPerPage}`,
                    method  : 'GET'
                }
                await Promise.all([ this.axios(countTransactions), this.axios(searchTransactions) ]).then(values => {
                    this.countItem = values[0].data.data
                    this.myItem    = values[1].data.data
                    $(".data-item-table-setting.v-data-table > .v-data-table__wrapper").scrollTop(0)
                }).catch(error => {
                    this.myItem = []
                    this.countItem = 0
                    this.alert('กรุณาลองใหม่อีกครั้ง', 'Fail', 'error')
                    console.log(error)
                }).finally(() => {
                    this.isReady = true
                    this.callApiPending--
                    this.trigRowPerPage = false
                })
            },
            goToAddItem(){
                EventBus.$emit('openAddItemDetail')
            },
            detailItem(item) {
                this.loadingState = true;
                this.setTimeOutResize = setTimeout(() => {
                    this.loadingState = false;
                    EventBus.$emit('openDetailItem', item);
                }, 500);
            },
            alert(title = '', text = 'Fail', icon = 'info') {
                this.$swal({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    icon: icon,
                    title: `<b class="alert-success-title">${title}</b>`,
                    text:  text,
                    showClass: {
                        popup: 'animate-show-card'
                    },
                    customClass: {
                        container: 'alert-card-block',
                        popup: 'alert-card-success',
                        title: 'alert-title-block',
                        htmlContainer: 'alert-text-box',
                        icon: 'alert-icon'
                    }
                })
            }
        }
    }
</script>

<style>
    .background-card {
        box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.25) !important;
        margin: 60px 4.51% 56px 4.51% !important;
        border-radius: 23px !important;
    }

    .data-item-table-setting tr {
         pointer-events: auto;
    }

    .search-item-btn {
        font-size: 15px;
        font-weight: 700;
        border: 1px solid #000000 !important;
        box-shadow: none;
    }

    .search-item-btn.v-btn:not(.v-btn--round).v-size--default {
        height: 53px !important;
        width: 108px;
        border-radius: 0px 15px 15px 0px;
    }

    .search-text-field .v-input__control .v-input__slot {
        padding-right: 0px !important;
    }

    .search-text-field {
        font-size: 18px !important;
        border-radius: 15px;
    }

    .search-text-field.v-text-field--outlined fieldset {
        border-color: black !important;
    }

    .data-item-table-setting thead th {
        height: 49px !important;
        background-color: #333333 !important;
        color: #FFFFFF !important;
        font-size: 20px;
    }

    .data-item-table-setting thead th:first-child {
        border-radius: 10px 0 0 0;
    }

    .data-item-table-setting thead th:last-child {
        border-radius: 0 10px 0 0;
    }

    .data-item-table-setting thead th {
        font-size: 20px !important;
        font-weight: 400;
    }

    .data-item-table-setting.v-data-table--fixed-header > .v-data-table__wrapper > table > thead > tr > th {
        position: sticky;
        top: 0;
        z-index: 2;
    }

    .data-item-table-setting .v-data-table__wrapper table tbody tr td {
        padding-top: 0px;
        height: 49px !important;
    }

    .data-item-table-setting tbody tr td {
        border-left: 1px solid #D8D5D5 !important;
        border-right: 1px solid #D8D5D5 !important;
        border-bottom: 0px !important;
    }

    .data-item-table-setting tbody tr td:first-child {
        border-left: 0px !important;
        border-right: 1px solid #D8D5D5 !important;
        border-bottom: 0px !important;
    }

    .data-item-table-setting tbody tr td:last-child {
        border-left: 1px solid #D8D5D5 !important;
        border-right: 0px !important;
        border-bottom: 0px !important;
    }

    .data-item-table-setting tbody tr:nth-of-type(even) {
        background: #F8F5F5;
    }

    .search-text-field .v-input__control .v-input__slot .v-text-field__slot input {
        line-height: 30px;
    }

    .data-item-table-setting .v-data-table__wrapper table tbody tr td {
        border-left: none !important;
    }

    .data-item-table-setting.v-data-table > .v-data-table__wrapper {
        height: calc(100vh - 174px);
        overflow: auto;
        scroll-behavior: smooth;
    }

    .data-item-table-setting tbody tr:nth-of-type(even) {
        background: #F8F5F5;
    }

    .data-item-table-setting.v-data-table > .v-data-table__wrapper::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: transparent !important;
    }

    .data-item-table-setting.v-data-table > .v-data-table__wrapper::-webkit-scrollbar {
        width: 8px;
        height: 8px;
        background-color: transparent !important;
    }

    .data-item-table-setting.v-data-table > .v-data-table__wrapper::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #F8F5F5;
    }
    .data-item-table-setting tbody tr {
        cursor: pointer;
    }

    .download-report-item-btn {
        font-weight: 700;
        font-size: 15px;
        border: none !important;
        border-radius: 20px;
        box-shadow: none !important;
    }

    @media only screen and (max-width: 849px) {

        .data-item-table-setting tbody tr td:first-child {
            border-top: 1px solid #D8D5D5 !important;
            border-left: 1px solid #D8D5D5 !important;
        }

        .data-item-table-setting tbody tr td:last-child {
            border-right: 1px solid #D8D5D5 !important;
            border-bottom: 1px solid #D8D5D5 !important;
        }

        .data-item-table-setting .v-data-table__wrapper table tbody .v-data-table__empty-wrapper td {
            width: 100vw;
            border-right: none !important;
            border-bottom: none !important;
        }
    }
</style>